import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
} from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { getViewportHeight } from '@common';
import {
  Gateway,
  InstallationDetailsStore,
  InstallationsSearchState,
  InstallationsSearchStore,
  SearchStore,
} from '@store';
import { GatewaySearch } from '@vi-iot/client';

import { Observable } from 'rxjs';
import { SearchService } from '../../../../+search/search.service';

@Component({
  selector: 'app-installations-search-results',
  templateUrl: './installations-search-results.component.html',
  styleUrls: ['./installations-search-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationsSearchResultsComponent implements OnInit {
  @Output() fetchNext = new EventEmitter();
  @Input() dataState$: Observable<InstallationsSearchState>;
  @Input() searchParams;
  searchedGateway$: Observable<Gateway[]>;
  itemSize = 206;
  nextBatch = false;
  getViewportHeight = getViewportHeight;

  constructor(
    public searchService: SearchService,
    public installationDetailsStore: InstallationDetailsStore,
    public installationSearchStore: InstallationsSearchStore,
    private searchStore: SearchStore,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.searchedGateway$ = this.installationSearchStore.searchedGateway$;
  }

  onFetchNextInstallations(next: { offset?: number; limit: number; cursor?: string }): void {
    this.searchStore.fetchMoreInstallations(this.searchParams, next.limit, next.cursor);
  }

  onNextBatchChange($event: boolean): void {
    this.fetchNext.emit();
    this.nextBatch = $event;
  }

  navigateToInstallations(gateway: GatewaySearch): void {
    if (gateway.registeredAt) {
      const navigationExtras: NavigationExtras = gateway.serial
        ? { state: { searchBreadcrumb: true }, queryParams: { gatewaySerial: gateway.serial } }
        : { state: { searchBreadcrumb: true } };
      this.router.navigate([`/installations/${gateway.installationId}`], navigationExtras);
    }
  }
}
